import { fetchDatasourcePoliciesCount } from '../../../../dashboardSummary/dashboardSummarySlice'
import { IGetDatasourcePoliciesCountParams } from '../../../../dashboardSummary/queries'
import Template1SummaryCountWidget from '../../../template1/components/Template1SummaryCountWidget'
import SlackCountsWidget from '../../../slack/components/SummaryCountsWidget'
import TeamsCountsWidget from '../../../teams/components/TeamsSummaryWidget'
import GenericCountsWidget from '../../../generic/components/SummaryCountWidget'
import JiraCountsWidget from '../../../jira/components/SummaryCountWidget'
import MailsSummaryWidget from '../../../template2/components/MailsSummaryCountsWidget'
import AwsS3SummaryWidget from '../../../awsS3/components/SummaryCountWidget'
import MsVivaEngageCountsWidget from '../../../msVivaEngage/SummaryCountsWidget'
import SmbSummaryWidget from '../../../smb/components/SummaryCountWidget'
import CopilotSummaryWidget from '../../../copilot/components/SummaryCountsWidget'
import { DATA_SOURCE_TYPES, TEMPLATE1_DATASOURCES } from '../../../../../constants'
import useUrlContext from '../../../../../hooks/useUrlContext'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../constants'
import { connect } from 'react-redux'
import React, { useEffect } from 'react'

const datasourceSummaryMapping = {
  [DATA_SOURCE_TYPES.slack]: SlackCountsWidget,
  [DATA_SOURCE_TYPES.msVivaEngage]: MsVivaEngageCountsWidget,
  [DATA_SOURCE_TYPES.teams]: TeamsCountsWidget,
  [DATA_SOURCE_TYPES.gmail]: MailsSummaryWidget,
  [DATA_SOURCE_TYPES.outLook]: MailsSummaryWidget,
  [DATA_SOURCE_TYPES.exchange]: MailsSummaryWidget,
  [DATA_SOURCE_TYPES.generic]: GenericCountsWidget,
  [DATA_SOURCE_TYPES.jira]: JiraCountsWidget,
  [DATA_SOURCE_TYPES.aws]: AwsS3SummaryWidget,
  [DATA_SOURCE_TYPES.googleCloudStorage]: AwsS3SummaryWidget,
  [DATA_SOURCE_TYPES.azureBlob]: AwsS3SummaryWidget,
  [DATA_SOURCE_TYPES.oracleObjectStorage]: AwsS3SummaryWidget,
  [DATA_SOURCE_TYPES.smb]: SmbSummaryWidget,
  [DATA_SOURCE_TYPES.box]: Template1SummaryCountWidget,
  [DATA_SOURCE_TYPES.dropbox]: Template1SummaryCountWidget,
  [DATA_SOURCE_TYPES.copilot]: CopilotSummaryWidget,
  ...TEMPLATE1_DATASOURCES.reduce((acc, datasource) => {
    acc[datasource] = Template1SummaryCountWidget
    return acc
  }, {})
}

interface IProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDashboardId?: string
  widgetDatasourceType?: DATA_SOURCE_TYPES
  fetchDatasourcePoliciesCount: (
    params: IGetDatasourcePoliciesCountParams & { [UNIQUE_WIDGET_INDEX]: string }
  ) => void
}

const SummaryCountsWidget = ({
  useMockData = false,
  widgetDatasourceId,
  widgetDatasourceType,
  widgetDashboardId,
  fetchDatasourcePoliciesCount
}: IProps) => {
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId ? widgetDatasourceId : context.contextFilters.datasourceId
  const datasourceType = widgetDatasourceType
    ? widgetDatasourceType
    : (context.queryParams.datasourceType as DATA_SOURCE_TYPES)

  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  useEffect(() => {
    if (useMockData) return
    datasourceId &&
      fetchDatasourcePoliciesCount({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
  }, [datasourceId, fetchDatasourcePoliciesCount, useMockData, widgetIndex])

  const SummaryWidget = datasourceSummaryMapping[datasourceType]
  return SummaryWidget ? (
    <SummaryWidget
      useMockData={useMockData}
      widgetDatasourceId={widgetDatasourceId}
      widgetDatasourceType={widgetDatasourceType}
      widgetDashboardId={widgetDashboardId}
    />
  ) : (
    <></>
  )
}

const mapDispatchToProps = {
  fetchDatasourcePoliciesCount
}

export default connect(null, mapDispatchToProps)(SummaryCountsWidget)
